// extracted by mini-css-extract-plugin
export default {"infopanel":"InfoPanel_infopanel__BSTk7","date":"InfoPanel_date__Z8i6J","summary":"InfoPanel_summary__oqtg8","time":"InfoPanel_time__u+99k","onlive":"InfoPanel_onlive__9NxBE"};